/* eslint-disable array-callback-return */
// @ts-nocheck
import React, { useContext, Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { ActaAuthContext } from "pa_kit/auth";
import { SubscriberAuthContext } from "services/auth_subscribers";
import ActaAuthUtils from 'pa_kit/utils';


const AppRoutes = () => {

    const auth = useContext(ActaAuthContext);
    const subscriber_auth = useContext(SubscriberAuthContext);

    ActaAuthUtils.setSelectedRole("staff");

    const theme = auth.theme;  

    const defaultTheme = {
        "--color-primary": theme.primary_color,
        "--color-secondary": theme.secondary_color,
        "--color-tertiary": theme.tertiary_color,
        "--color-quaternary": theme.quaternary_color,
    }    

    const applyTheme = (theme) => {
        Object.keys(theme).map((key) => {
            const value = theme[key];
            document.documentElement.style.setProperty(key, value);
        });
    };
    
    applyTheme(defaultTheme);
    
    const user = auth.user;
   
    const Login = lazy(() => import('services/login'));
    const App = lazy(() => import('./app'));
    const Dashboard = lazy(() => import('apps/dashboard/dashboard'));
    const ActivitiesList = lazy(() => import('apps/activities/components/activities_list'));
    const SearchSubscribers = lazy(() => import('apps/subscribers/components/search_subscribers'));
    const CreateSubscriber = lazy(() => import('apps/subscribers/components/create_subscriber'));
    const SubscriberProfile = lazy(() => import('apps/subscribers/components/subscriber_profile'));
    const UserProfile = lazy(() => import('apps/subscribers/components/user_profile'));
    const MessagesList = lazy(() => import('apps/messages/components/messages_list'));
    const EditSubscriber = lazy(() => import('apps/subscribers/components/edit_subscriber'));
    const ManageSubscription = lazy(() => import('apps/subscribers/components/manage_subscription'));
    const SubscribersList = lazy(() => import('apps/subscribers/components/subscribers_list'));
    const ExpireList = lazy(() => import('apps/subscribers/components/expire_list'));
    const TransfersList = lazy(() => import('apps/subscribers/components/transfers_list'));
    const RequestTransfer = lazy(() => import('apps/subscribers/components/request_transfer'));
    const OrdersList = lazy(() => import('apps/orders/components/orders_list'));
    const CreateOrder = lazy(() => import('apps/orders/components/create_order'));
    const EditOrder = lazy(() => import('apps/orders/components/edit_order'));
    const MagazinesList = lazy(() => import('apps/magazines/components/magazines_list'));
    const CreateMagazine = lazy(() => import('apps/magazines/components/create_magazine'));
    const UsersList = lazy(() => import('apps/users/components/users_list'));
    const UniversitiesList = lazy(() => import('apps/university/components/universities_list'));
    const CreateUniversity = lazy(() => import('apps/university/components/create_university'));
    const EditUniversity = lazy(() => import('apps/university/components/edit_university'));
    const SistemaTSList = lazy(() => import('apps/subscribers/components/sistema_ts_list'));
    const Print = lazy(() => import('apps/print/components/print'));
    const ExportAnagrafeTributaria = lazy(() => import('apps/print/components/export_anagrafe_tributaria'));

    if(auth.isLoading) return <div></div>;
    if(subscriber_auth.isSubscriberLoading) return <div></div>;
    return <>
        <BrowserRouter>
            <Suspense fallback={<div></div>}>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/admin" element={<Navigate to="/" />} />
                    <Route path="/" element={user ? <App /> : <Navigate to="/login" />} >
                        <Route path="" element={user ? <Dashboard /> : <Navigate to="/login" />} ></Route>
                        <Route path="search" element={user && (user.is('albo') || user.is('fnopo')) ? <SearchSubscribers /> : <Navigate to="/profile" />} ></Route>
                        <Route path="create-subscriber" element={user && user.is('albo') ? <CreateSubscriber /> : <Navigate to="/profile" />} ></Route>
                        <Route path="subscriber/:fiscalCode" element={user && (user.is('albo') || user.is('fnopo')) ? <SubscriberProfile /> : <Navigate to="/profile" />} />
                        <Route path="edit-subscriber/:fiscalCode" element={user && user.is('albo') ? <EditSubscriber /> : <Navigate to="/profile" />} />
                        <Route path="manage-subscription/:fiscalCode" element={user && user.is('albo') ? <ManageSubscription /> : <Navigate to="/profile" />} />
                        <Route path="subscribers-list" element={user && (user.is('albo') || user.is('fnopo')) ? <SubscribersList /> : <Navigate to="/profile" />} />
                        <Route path="expire-list" element={user && user.is('albo') ? <ExpireList /> : <Navigate to="/profile" />} />
                        <Route path="transfers-list" element={user && user.is('albo') ? <TransfersList /> : <Navigate to="/profile" />} />
                        <Route path="request-transfer" element={user && user.is('albo') ? <RequestTransfer /> : <Navigate to="/profile" />} />
                        <Route path="activities" element={user && (user.is('albo') || user.is('fnopo')) ? <ActivitiesList /> : <Navigate to="/profile" />} ></Route>
                        <Route path="magazines" element={user && (user.is('albo') || user.is('fnopo')) ? <MagazinesList /> : <Navigate to="/profile" />} ></Route>
                        <Route path="create-magazine" element={user && (user.is('albo') || user.is('fnopo')) ? <CreateMagazine /> : <Navigate to="/profile" />} ></Route>
                        <Route path="sistema-ts" element={user && (user.is('albo') || user.is('fnopo')) ? <SistemaTSList /> : <Navigate to="/profile" />} ></Route>
                        <Route path="print" element={user && (user.is('albo') || user.is('fnopo')) ? <Print /> : <Navigate to="/profile" />} ></Route>
                        <Route path="anagrafe-tributaria" element={user && (user.is('albo') || user.is('fnopo')) ? <ExportAnagrafeTributaria /> : <Navigate to="/profile" />} ></Route>

                        <Route path="orders" element={user && user.is('fnopo') ? <OrdersList /> : <Navigate to="/profile" />} ></Route>
                        <Route path="create-order" element={user && user.is('fnopo') ? <CreateOrder /> : <Navigate to="/profile" />} ></Route>
                        <Route path="edit-order/:idOrder" element={user && user.is('fnopo') ? <EditOrder /> : <Navigate to="/profile" />} ></Route>
                        <Route path="universities" element={user && user.is('fnopo') ? <UniversitiesList /> : <Navigate to="/profile" />} ></Route>
                        <Route path="create-university" element={user && user.is('fnopo') ? <CreateUniversity /> : <Navigate to="/profile" />} ></Route>
                        <Route path="edit-university/:idUniversity" element={user && user.is('fnopo') ? <EditUniversity /> : <Navigate to="/profile" />} ></Route>
                        <Route path="manage-users" element={user && user.is('fnopo') ? <UsersList /> : <Navigate to="/profile" />} ></Route>

                        <Route path="profile" element={user && (subscriber_auth.isSubscriber || user.is('albo')) ? <UserProfile /> : <Navigate to="/login" />} />
                        <Route path="messages" element={user && (subscriber_auth.isSubscriber || user.is('albo')) ? <MessagesList /> : <Navigate to="/login" />} />
                    </Route>
                </Routes>
            </Suspense>
        </BrowserRouter>
    </>;
}

export default AppRoutes;
